// extracted by mini-css-extract-plugin
export default {"menu":"MenuIcon_menu_nHwqX"};